<template>
  <DashboardTemplate :navMenu="true">
    <div class="pd-b-3 disabled-on-print text-left">
      <h3 class="mg-y-less text-font-24">
        ข้อมูลหลักสูตร {{ getPrefixLabel(prefix) }}{{ nameTh }} {{ lastNameTh }}
      </h3>

    </div>
    <el-tabs v-model="activeName" class="secondary disabled-on-print" @tab-click="$router.push(`/name/list/activity?userId=${userId}&tab=${activeName}`).catch(()=>{})">
      <el-tab-pane label="หลักสูตรที่กำลังเรียน" name="1" >
        <div class="pd-t-4">
          <div class="box-overflow normal">
            <ActivityList :doneCourse="false" :activityList="studingList" :userId="userId"/>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="หลักสูตรที่เรียนจบแล้ว" name="2">
        <div class="pd-t-4">
          <div class="box-overflow normal">
            <ActivityList
              :activityList="successList"
              :userId="userId"
              @printCertificate="printCertificate"
            />
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <div class="show-only">
      <div class="certificate-print-box">
        <CertificateCard
          :name="nameTh"
          :lastName="lastNameTh"
          :courseName="courseName"
          :endDate="endDate"
        />
      </div>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import ActivityList from "@/components/activity/ActivityList";
import CertificateCard from "@/components/certificate/CertificateCard";
import { HTTP } from "@/service/axios.js";

export default {
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  components: {
    DashboardTemplate,
    ActivityList,
    CertificateCard,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    prefixList() {
      return this.$store.state.prefixList;
    },
  },
  data() {
    return {
      activeName: "1",
      userId: "",
      prefix: "",
      nameTh: "",
      lastNameTh: "",
      courseName: "",
      endDate: "",
      studingList: [],
      successList: [],
    };
  },
  mounted() {
    this.setParams();
    this.fetchStudentsById();
    this.fetchCourseByUser();
  },
  methods: {

    setParams() {
      if (this.routeParams != null) {
        this.userId = this.routeParams.userId;
        if (typeof this.routeParams.tab != 'undefined') {
          this.activeName = this.routeParams.tab
        }
      }
    },
    fetchStudentsById() {
      let obj = {
        _id: this.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/student`, obj)
        .then((res) => {
          if (res.data.success) {
            this.prefix = res.data.obj.titleName;
            this.nameTh = res.data.obj.nameTH;
            this.lastNameTh = res.data.obj.surnameTH;
          }
        })
        .catch((e) => {
          console.log("fetchStudentsById error", e);
        });
    },
    getPrefixLabel(id) {
      let filter = this.prefixList.filter((filter) => filter.id == id);
      if (filter.length > 0) {
        return filter[0].label;
      }
    },
    fetchCourseByUser() {
      let obj = {
        userId: this.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`percent/course`, obj)
        .then((res) => {

          if (res.data.success) {
            this.studingList = res.data.obj.studing;
            this.successList = res.data.obj.success;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchCourseByUser error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    printCertificate(name, endDate) {
      this.courseName = name;
      this.endDate = endDate;

      setTimeout(() => {
        window.print();
      }, 500);
    },
  },
};
</script>